export default "__VITE_ASSET__BrQskKQi__"